import { useState } from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import {
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
} from "reactstrap";
import React,{useContext} from 'react';
import { useHistory } from "react-router-dom";
import UserContext from "../../components/UserContext";
import logoImg from "../../assets/img/theme/fempulse.png"

const Sidebar = (props) => {
  const userContext = useContext(UserContext);
  const history = useHistory();
  const [collapseOpen, setCollapseOpen] = useState();
  // verifies if routeName is the one active (in browser input)

  // toggles collapse between opened and closed (true/false)
  const toggleCollapse = () => {
    setCollapseOpen((data) => !data);
  };
  // closes the collapse
  const closeCollapse = () => {
    setCollapseOpen(false);
  };
  // creates the links that appear in the left menu / Sidebar
  const createLinks = (routes) => {
    return routes.map((prop, key) => {
      return (
        <NavItem key={key}>
          <NavLink
            to={prop.layout + prop.path}
            tag={NavLinkRRD}
            onClick={closeCollapse}
            activeClassName="active"
          >
            <i className={prop.icon} />
            {prop.name}
          </NavLink>
        </NavItem>
      );
    });
  };

  const { routes, logo } = props;
  let navbarBrandProps;
  if (logo && logo.innerLink) {
    navbarBrandProps = {
      to: logo.innerLink,
      tag: Link,
    };
  } else if (logo && logo.outterLink) {
    navbarBrandProps = {
      href: logo.outterLink,
      target: "_blank",
    };
  }
  var doLogout = () => {
    userContext.doLogin("logged-out");
    history.push("/admin")
  }

  return (
<>
     <style>{`
      #sidenav-main {
        box-shadow: 2px 0 8px rgba(0, 0, 0, 0.12) !important;
      }
         @media (max-width: 767.98px) {
    #sidenav-main {
      min-height: auto !important;
    }
     }

    `}</style>

   <Navbar
  className="navbar-vertical fixed-left navbar-light bg-white"
  expand="md"
  id="sidenav-main"
  style={{ display: "flex", flexDirection: "column", zIndex: 1000, }}
>
      <Container fluid>
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span className="navbar-toggler-icon" />
        </button>
        {logo ? (
          <NavbarBrand className="pt-0" {...navbarBrandProps}>
            <img
              alt={logo.imgAlt}
              className="navbar-brand-img"
              src={logoImg}
            />
          </NavbarBrand>
        ) : null}
        {/* User */}
        <Nav className="align-items-center d-md-none">
          <UncontrolledDropdown nav>
            <DropdownToggle nav>
              <Media className="align-items-center">
                <span className="avatar avatar-sm rounded-circle">
                  <img
                    alt="..."
                      style={{
    width: "40px",
    height: "40px",
    objectFit: "cover",
  }}
                    src={
                      require("../../assets/img/theme/img_avatar.jpg")
                        .default
                    }
                  />
                </span>
              </Media>
            </DropdownToggle>
            <DropdownMenu className="dropdown-menu-arrow" right>
              <DropdownItem href="" onClick={doLogout}>
              <i className='fas fa-sign-out-alt' style={{color:'red'}}></i>
                <span>Logout</span>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
        </Nav>
       <Collapse navbar isOpen={collapseOpen} style={{ flexGrow: 1, overflowY: "auto" }}>
  <div className="navbar-collapse-header d-md-none">
    <Row>
      <Col className="collapse-close" xs="">
        <button
          className="navbar-toggler"
          type="button"
          onClick={toggleCollapse}
        >
          <span />
          <span />
        </button>
      </Col>
    </Row>
  </div>

  <Nav navbar>{createLinks(routes)}</Nav>
</Collapse>

<div
  className="d-none d-md-block"
  style={{
    marginTop: "auto",
    padding: "1rem 1.5rem",
    borderTop: "1px solid #e9ecef",
    fontSize: "0.875rem",
    color: "#525356",
  }}
>
  © {new Date().getFullYear()}{" "}
  <a
    href="https://fempulse.com/home/"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      color: "#969aa2",
      fontWeight: "600",
      textDecoration: "none"
    }}
  >
    FemPulse
  </a>
</div>

      </Container>
    </Navbar>
    </>
  );
};

Sidebar.defaultProps = {
  routes: [{}],
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired,
  }),
};

export default Sidebar;
